(() => {
  if (customElements.get('welcome-offer')) return;

  customElements.define('welcome-offer', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const editor = this.dataset.editor === 'true';
      const read = (key) => { try { return sessionStorage.getItem(key); } catch { return null; } };
      const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch { /* Storage is optional. */ } };
      const response = this.querySelector('[data-offer-success], [data-offer-error]');
      const ownResponse = response && (location.hash === '#WelcomeOfferForm' || read('welcome-offer-pending') === 'true');

      this.open = () => {
        if (!this.isConnected || this.dialog.open) return;
        // Avoid covering another modal, including the professional application.
        if (document.querySelector('dialog[open], [data-haven-popup-open="true"], details[open] [aria-modal="true"]')) {
          this.timer = setTimeout(this.open, 1000);
          return;
        }
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
      };
      this.querySelector('[data-offer-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        if (!editor) write('welcome-offer-dismissed', 'true');
        if (this.previousFocus?.isConnected) this.previousFocus.focus();
      }, options);
      this.querySelector('form')?.addEventListener('submit', () => write('welcome-offer-pending', 'true'), options);

      if (editor) {
        this.closest('.shopify-section')?.addEventListener('shopify:section:select', this.open, options);
        this.closest('.shopify-section')?.addEventListener('shopify:section:deselect', () => {
          clearTimeout(this.timer);
          this.dialog.close();
        }, options);
      } else if (ownResponse) {
        write('welcome-offer-pending', 'false');
        if (this.querySelector('[data-offer-success]')) write('welcome-offer-dismissed', 'true');
        this.open();
      } else if (this.dataset.eligible === 'true' && !read('welcome-offer-dismissed') && !response) {
        this.timer = setTimeout(this.open, Number(this.dataset.delay) || 0);
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.dialog?.close();
    }
  });
})();
